


import { Vue, Component } from 'vue-property-decorator';
import LoadingAnimationComponent from '@/vue/components/LoadingAnimationComponent.vue';

@Component(
	{
		components:
		{
			LoadingAnimationComponent,
		},
	},
)
export default class RootView extends Vue
{
	private created()
	{
		const query = this.$route.query;

		// クエリによって表示先を変更する
		if ( query && query.disable )
		{
			this.$http.post(
				this.$store.state.apiPath + 'disable_url',
				{
					sid: query.disable,
				},
			)
			.then( (res) =>
				{
					// パスワードリセット中止ページへ
					this.$router.replace({ name: 'disabled_url' });
				},
			)
			.catch( (err) =>
				{
					// サーバーからのエラーレスポンス
					if ( err.response )
					{
						const code: number = err.response.data!.error_code;
						switch (code)
						{
							// リクエストパラメータ関係のエラー
							// MEMO: ブラウザから実行する場合、フロントエンド側で正しい実装をしていれば絶対に通らないはず
							case 2201300:
							case 2201301:
								this.$router.replace(
									{
										name: 'error',
										query:
										{
											code: code.toString(),
											msgId: 'param_error',
										},
									},
								);
								return;

							// サーバー関連のエラー
							// MEMO: ブラウザから実行する場合、フロントエンド側で正しい実装をしていれば絶対に通らないはず
							case 2200305:
								this.$router.replace(
									{
										name: 'error',
										query:
										{
											code: code.toString(),
											msgId: 'server_error',
										},
									},
								);
								return;
						}
					}


					// サーバーからのレスポンスがない場合はタイムアウトと見做す
					this.$router.replace(
						{
							name: 'error',
							query:
							{
								code: '2200999',
								msgId: 'timed_out',
							},
						},
					);
				},
			);
		}
		else if ( query && query.sid )
		{
			this.$http.post(
				this.$store.state.apiPath + 'get_reset_token',
				{
					sid: query.sid,
				},
			)
			.then( (res) =>
				{
					// 新パスワード入力ページへ
					this.$router.replace({ name: 'password_reset' });
				},
			)
			.catch( (err) =>
				{
					if ( err.response )
					{
						const code: number = err.response.data!.error_code;
						switch (code)
						{
							// リクエストパラメータ関係のエラー
							// MEMO: ブラウザから実行する場合、フロントエンド側で正しい実装をしていれば絶対に通らないはず
							case 2201300:
							case 2201301:
							case 2201302:
								this.$router.replace(
									{
										name: 'error',
										query:
										{
											code: code.toString(),
											msgId: 'param_error',
										},
									},
								);
								return;

							// セッション関係のエラー
							case 2201303:
								this.$router.replace(
									{
										name: 'error',
										query:
										{
											code: code.toString(),
											msgId: 'sid_expired',
										},
									},
								);
								return;

							// サーバー関連のエラー
							// MEMO: ブラウザから実行する場合、フロントエンド側で正しい実装をしていれば絶対に通らないはず
							case 2200305:
								this.$router.replace(
									{
										name: 'error',
										query:
										{
											code: code.toString(),
											msgId: 'server_error',
										},
									},
								);
								return;
						}
					}

					// タイムアウト
					this.$router.replace(
						{
							name: 'error',
							query:
							{
								code: '2200999',
								msgId: 'timed_out',
							},
						},
					);
				},
			);
		}
		else
		{
			this.$http.get(
				this.$store.state.apiPath + 'begin_process',
			)
			.then( (res) =>
				{
					// メールリクエストページへ
					this.$router.replace({ name: 'mail_request' });
					return;
				},
			)
			.catch( (err) =>
				{
					// サーバーからのエラーレスポンス
					if ( err.response )
					{
						const code: number = err.response.data!.error_code;
						switch (code)
						{
							// リクエストパラメータ関係のエラー
							// MEMO: ブラウザから実行する場合、フロントエンド側で正しい実装をしていれば絶対に通らないはず
							case 2201300:
							case 2201301:
								this.$router.replace(
									{
										name: 'error',
										query:
										{
											code: code.toString(),
											msgId: 'param_error',
										},
									},
								);
								return;

							// サーバー関連のエラー
							// MEMO: ブラウザから実行する場合、フロントエンド側で正しい実装をしていれば絶対に通らないはず
							case 2200305:
								this.$router.replace(
									{
										name: 'error',
										query:
										{
											code: code.toString(),
											msgId: 'server_error',
										},
									},
								);
								return;
						}
					}

					// サーバーからのレスポンスがない場合はタイムアウトと見做す
					this.$router.replace(
						{
							name: 'error',
							query:
							{
								code: '2200999',
								msgId: 'timed_out',
							},
						},
					);
				},
			);
		}
	}
}
